import { ProductField, ProductFieldTag } from '../generated/types';

export function getChoiceNonActionFields(
  fields: ProductField[]
): ProductField[] {
  return fields.filter(({ tag }) => tag !== ProductFieldTag.Action);
}
